import { datePresetPaddingLeft } from "../utils/dateUtils";
import { Box, Chip, Typography } from "@mui/material";
import { reportsV3DatePresetIndentPx } from "config";
import React from "react";
import * as staticDataHooks from "store/hooks/staticDataHooks";

const DatePresetRow = ({
  label,
  presets,
  isSelected,
  onSelect,
  divider = false,
}) => {
  const translateLabels = staticDataHooks.useTranslator("uiLabels");
  return (
    <Box
      role={"group"}
      aria-label={label}
      sx={{
        display: "grid",
        gridTemplateColumns: "subgrid",
        gridColumn: "1 / -1",
        alignItems: "start",
        columnGap: 1,
        pl: (theme) =>
          datePresetPaddingLeft(theme, reportsV3DatePresetIndentPx()),
        pr: 2,
        py: 0.5,
        borderTop: divider ? 1 : 0,
        borderColor: "divider",
      }}
    >
      <Typography variant={"body2"}>{label}</Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
        {presets.map((preset) => {
          const selected = isSelected(preset);
          return (
            <Chip
              key={preset.key}
              size={"small"}
              label={translateLabels(preset.chipLabelKey, {
                default: preset.chipDefaultLabel,
              })}
              color={selected ? "primary" : "default"}
              variant={selected ? "filled" : "outlined"}
              aria-pressed={selected}
              onClick={() => onSelect(preset)}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default DatePresetRow;
